import { render } from "./AuthSuccess.vue?vue&type=template&id=0dc1a4d8"
import script from "./AuthSuccess.vue?vue&type=script&lang=js"
export * from "./AuthSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__